var Backbone, EmailFormOptimizedContactChannelView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormOptimizedContactChannelView = (function(superClass) {
  extend(EmailFormOptimizedContactChannelView, superClass);

  function EmailFormOptimizedContactChannelView() {
    return EmailFormOptimizedContactChannelView.__super__.constructor.apply(this, arguments);
  }

  EmailFormOptimizedContactChannelView.prototype.className = 'optimized-contact-channels-view';

  EmailFormOptimizedContactChannelView.prototype.events = {
    'click .optimized-email-us': 'optimizedContactByEmail',
    'DOMSubtreeModified .live-chat-container.optimized-contact-channel': 'handleDisplayOfOptimizedChannels',
    "click .optimized-phone-btn": "renderPhoneNumberView",
    'click .live-chat-container.optimized-contact-channel': 'chatClicked'
  };

  EmailFormOptimizedContactChannelView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.model = Groupon.Support.OptimizedContactChannelsModel;
    this.mainView = this.options.mainView;
    return this.emailFormModel = this.options.emailFormModel;
  };

  EmailFormOptimizedContactChannelView.prototype.render = function() {
    this.$el.append(toHtml(this.model.template, this.toHash(), this.I18nScope));
    return this;
  };

  EmailFormOptimizedContactChannelView.prototype.toHash = function() {
    return $.extend({
      isLiveChatEnabled: this.isLiveChatEnabled(),
      isPhonePreferredChannel: this.mainView.isPhonePreferredChannel()
    }, this.model.toHash());
  };

  EmailFormOptimizedContactChannelView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormOptimizedContactChannelView.prototype.optimizedContactByEmail = function(event) {
    this.model.hidePreferencedContactChannel();
    this.model.showPreferencedContactChannel("email");
    return this.mainView.renderEmailForm();
  };

  EmailFormOptimizedContactChannelView.prototype.handleDisplayOfOptimizedChannels = function() {
    var emailUsParagraphElems, liveChatContainerElem, phoneParagraphElems;
    liveChatContainerElem = this.model.optimizedLiveChatContainer();
    emailUsParagraphElems = this.model.emailRecommendationTextElement();
    phoneParagraphElems = this.model.phoneRecommendationTextElement();
    this.model.hidePreferencedContactChannel();
    this.model.setOptimizedLiveChatDisplayCallBack(this.handleDisplayOfOptimizedChannels);
    if (this.model.optimizedLiveChatVisible()) {
      showDOMElems(liveChatContainerElem);
      hideDOMElems([emailUsParagraphElems, phoneParagraphElems]);
      return this.model.showPreferencedContactChannel("chat");
    } else {
      hideDOMElems(liveChatContainerElem);
      if (this.emailFormModel.isMethodOfContactByPhone() || this.emailFormModel.isMethodOfContactByPhoneWithEmail()) {
        this.model.showPreferencedContactChannel("phone");
        hideDOMElems(emailUsParagraphElems);
        return showDOMElems(phoneParagraphElems);
      } else {
        this.model.showPreferencedContactChannel("email");
        hideDOMElems(phoneParagraphElems);
        return showDOMElems(emailUsParagraphElems);
      }
    }
  };

  EmailFormOptimizedContactChannelView.prototype.handleDisplayOfContactChannels = function() {
    return this.handleDisplayOfOptimizedChannels();
  };

  EmailFormOptimizedContactChannelView.prototype.renderPhoneNumberView = function() {
    this.model.hidePreferencedContactChannel();
    this.model.showPreferencedContactChannel("phone");
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormOptimizedContactChannelView.prototype.chatClicked = function() {
    this.model.hidePreferencedContactChannel();
    this.model.showPreferencedContactChannel("chat");
    return true;
  };

  EmailFormOptimizedContactChannelView.prototype.renderLiveChat = function() {
    return this.mainView.renderLiveChat({
      liveChatMode: 'static',
      liveChatType: Groupon.Support.LiveChatModel.getOptimizedLiveChatType()
    });
  };

  return EmailFormOptimizedContactChannelView;

})(Backbone.View);

module.exports = EmailFormOptimizedContactChannelView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vb3B0aW1pemVkX2NvbnRhY3RfY2hhbm5lbF92aWV3LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL3ZpZXdzL2VtYWlsX2Zvcm0vY29tbW9uL29wdGltaXplZF9jb250YWN0X2NoYW5uZWxfdmlldy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQSw4Q0FBQTtFQUFBOzs7QUFBQSxRQUFBLEdBQVcsT0FBQSxDQUFRLFVBQVI7O0FBQ1gsUUFBUSxDQUFDLENBQVQsR0FBYTs7QUFFUDs7Ozs7OztpREFDSixTQUFBLEdBQVc7O2lEQUVYLE1BQUEsR0FDRTtJQUFBLDJCQUFBLEVBQTZCLHlCQUE3QjtJQUNBLG1FQUFBLEVBQXNFLGtDQUR0RTtJQUVBLDRCQUFBLEVBQWdDLHVCQUZoQztJQUdBLHNEQUFBLEVBQXlELGFBSHpEOzs7aURBS0YsVUFBQSxHQUFZLFNBQUMsT0FBRDtJQUNWLElBQUMsQ0FBQSxPQUFELEdBQVcsT0FBQSxJQUFXO0lBQ3RCLENBQUMsQ0FBQyxPQUFPLENBQUMsS0FBVixDQUFnQixDQUFoQixFQUFtQixDQUFDLElBQUQsQ0FBTSxDQUFDLE1BQVAsQ0FBYyxDQUFDLENBQUMsU0FBRixDQUFZLElBQVosQ0FBZCxDQUFuQjtJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7SUFDYixJQUFDLENBQUEsS0FBRCxHQUFTLE9BQU8sQ0FBQyxPQUFPLENBQUM7SUFDekIsSUFBQyxDQUFBLFFBQUQsR0FBWSxJQUFDLENBQUEsT0FBTyxDQUFDO1dBQ3JCLElBQUMsQ0FBQSxjQUFELEdBQWtCLElBQUMsQ0FBQSxPQUFPLENBQUM7RUFOakI7O2lEQVFaLE1BQUEsR0FBUSxTQUFBO0lBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxNQUFMLENBQVksTUFBQSxDQUFPLElBQUMsQ0FBQSxLQUFLLENBQUMsUUFBZCxFQUF3QixJQUFDLENBQUEsTUFBRCxDQUFBLENBQXhCLEVBQW1DLElBQUMsQ0FBQSxTQUFwQyxDQUFaO1dBQ0E7RUFGTTs7aURBSVIsTUFBQSxHQUFRLFNBQUE7V0FDTixDQUFDLENBQUMsTUFBRixDQUFTO01BQUMsaUJBQUEsRUFBbUIsSUFBQyxDQUFBLGlCQUFELENBQUEsQ0FBcEI7TUFBMEMsdUJBQUEsRUFBeUIsSUFBQyxDQUFBLFFBQVEsQ0FBQyx1QkFBVixDQUFBLENBQW5FO0tBQVQsRUFBa0gsSUFBQyxDQUFBLEtBQUssQ0FBQyxNQUFQLENBQUEsQ0FBbEg7RUFETTs7aURBR1IsaUJBQUEsR0FBbUIsU0FBQTtXQUNqQixPQUFPLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyxpQkFBOUIsQ0FBQTtFQURpQjs7aURBR25CLHVCQUFBLEdBQXlCLFNBQUMsS0FBRDtJQUN2QixJQUFDLENBQUEsS0FBSyxDQUFDLDZCQUFQLENBQUE7SUFDQSxJQUFDLENBQUEsS0FBSyxDQUFDLDZCQUFQLENBQXFDLE9BQXJDO1dBQ0EsSUFBQyxDQUFBLFFBQVEsQ0FBQyxlQUFWLENBQUE7RUFIdUI7O2lEQUt6QixnQ0FBQSxHQUFrQyxTQUFBO0FBQ2hDLFFBQUE7SUFBQSxxQkFBQSxHQUF3QixJQUFDLENBQUEsS0FBSyxDQUFDLDBCQUFQLENBQUE7SUFDeEIscUJBQUEsR0FBd0IsSUFBQyxDQUFBLEtBQUssQ0FBQyw4QkFBUCxDQUFBO0lBQ3hCLG1CQUFBLEdBQXNCLElBQUMsQ0FBQSxLQUFLLENBQUMsOEJBQVAsQ0FBQTtJQUV0QixJQUFDLENBQUEsS0FBSyxDQUFDLDZCQUFQLENBQUE7SUFDQSxJQUFDLENBQUEsS0FBSyxDQUFDLG1DQUFQLENBQTJDLElBQUMsQ0FBQSxnQ0FBNUM7SUFFQSxJQUFHLElBQUMsQ0FBQSxLQUFLLENBQUMsd0JBQVAsQ0FBQSxDQUFIO01BQ0UsWUFBQSxDQUFhLHFCQUFiO01BQ0EsWUFBQSxDQUFhLENBQUMscUJBQUQsRUFBd0IsbUJBQXhCLENBQWI7YUFDQSxJQUFDLENBQUEsS0FBSyxDQUFDLDZCQUFQLENBQXFDLE1BQXJDLEVBSEY7S0FBQSxNQUFBO01BS0UsWUFBQSxDQUFhLHFCQUFiO01BQ0EsSUFBRyxJQUFDLENBQUEsY0FBYyxDQUFDLHdCQUFoQixDQUFBLENBQUEsSUFBOEMsSUFBQyxDQUFBLGNBQWMsQ0FBQyxpQ0FBaEIsQ0FBQSxDQUFqRDtRQUNFLElBQUMsQ0FBQSxLQUFLLENBQUMsNkJBQVAsQ0FBcUMsT0FBckM7UUFDQSxZQUFBLENBQWEscUJBQWI7ZUFDQSxZQUFBLENBQWEsbUJBQWIsRUFIRjtPQUFBLE1BQUE7UUFLRSxJQUFDLENBQUEsS0FBSyxDQUFDLDZCQUFQLENBQXFDLE9BQXJDO1FBQ0EsWUFBQSxDQUFhLG1CQUFiO2VBQ0EsWUFBQSxDQUFhLHFCQUFiLEVBUEY7T0FORjs7RUFSZ0M7O2lEQXVCbEMsOEJBQUEsR0FBZ0MsU0FBQTtXQUM5QixJQUFDLENBQUEsZ0NBQUQsQ0FBQTtFQUQ4Qjs7aURBR2hDLHFCQUFBLEdBQXVCLFNBQUE7SUFDckIsSUFBQyxDQUFBLEtBQUssQ0FBQyw2QkFBUCxDQUFBO0lBQ0EsSUFBQyxDQUFBLEtBQUssQ0FBQyw2QkFBUCxDQUFxQyxPQUFyQztXQUNBLElBQUMsQ0FBQSxRQUFRLENBQUMscUJBQVYsQ0FBQTtFQUhxQjs7aURBS3ZCLFdBQUEsR0FBYSxTQUFBO0lBQ1gsSUFBQyxDQUFBLEtBQUssQ0FBQyw2QkFBUCxDQUFBO0lBQ0EsSUFBQyxDQUFBLEtBQUssQ0FBQyw2QkFBUCxDQUFxQyxNQUFyQztBQUNBLFdBQU87RUFISTs7aURBS2IsY0FBQSxHQUFnQixTQUFBO1dBQ2QsSUFBQyxDQUFBLFFBQVEsQ0FBQyxjQUFWLENBQXlCO01BQ3ZCLFlBQUEsRUFBYyxRQURTO01BRXZCLFlBQUEsRUFBYyxPQUFPLENBQUMsT0FBTyxDQUFDLGFBQWEsQ0FBQyx3QkFBOUIsQ0FBQSxDQUZTO0tBQXpCO0VBRGM7Ozs7R0FwRWlDLFFBQVEsQ0FBQzs7QUEwRTVELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
